import { useHistory } from "react-router-dom";
import CheckMarkSVG from "../assets/svg/CheckMarkSVG";
import Button from "../components/organism/Button";
import { useContext, useEffect } from "react";
import { PopUpContext } from "../services/context/popupContext";
import OrganizationAndClinicianSelection from "../components/popups/organizationAndClinicianSelectionPopup";
import PatientSelectionPopup from "../components/popups/patientSelectionPopup";
import { useOktaAuth } from "@okta/okta-react";
import useProfile from "../services/utils/custom hooks/useProfile";
import useFeatureFlags from "../services/utils/custom hooks/Feature Flagging/useFeatureFlags";
import dataConstants from "../constants/dataConstants";

export default function OrderAuthorizedPage() {
  const oktaAuth = useOktaAuth();
  const profile: any = useProfile();
  const { isSectionActive } = useFeatureFlags();
  const history = useHistory();
  const { visible, setVisible, setPopUp, setPopUpTitle, setOnlineOrder } =
    useContext(PopUpContext);
  const openPaitentFlowPopup = () => {
    setPopUpTitle("Choose or Create a Patient");
    setPopUp(<PatientSelectionPopup oktaAuth={oktaAuth} />);
    setOnlineOrder?.(false);
  };
  const roles = profile?.user?.roles ?? [];
  const isPLUPhysician = roles.includes("Physician") && roles.includes("PathLab User");
  const isPhysicianOnly = (roles.length === 1 && roles.includes("Physician")) || isPLUPhysician;

  function handleNewOnlineOrder() {
    setVisible(!visible);
    setPopUpTitle(
      `Select ${roles?.includes("Collaborative Order Agreement") ? "a PathLab" : ""
      } An organization ${isPhysicianOnly ? '' : 'and a clinician'}`
    );
    setPopUp(
      <OrganizationAndClinicianSelection handleNext={openPaitentFlowPopup} />
    );
  }

  useEffect(() => {
    if (!isSectionActive(dataConstants.FeatureFlagSectionKeys.APPROVALS)) {
      history.push("/unauthorized");
    }
  }, []);
  return (
    <div className="flex flex-col h-[calc(100vh_-_113px)] justify-center items-center">
      <CheckMarkSVG />
      <div className="w-4/6 md:w-2/6 text-center p-5">
        The order(s) has been approved and submitted successfully.
      </div>
      <div className="flex items-center">
        <Button
          buttonTheme="secondary"
          textInformation={{
            text: `Go to dashboard`,
            fontWeight: "font-semibold",
          }}
          className="mr-5"
          onClick={() => history.push("/access/dashboard")}
        />
        <Button
          buttonTheme="primary"
          textInformation={{
            text: `New Online Order`,
            fontWeight: "font-semibold",
          }}
          className=""
          onClick={() => handleNewOnlineOrder()}
        />
      </div>
    </div>
  );
}
